import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function Spotlights() {
  const {
    t
  } = useLanguage();
  return <section className="py-20 md:py-32 relative z-10 bg-surface/20 border-y border-white/5" data-id="element-254" data-mp="1ofyfyq9t9xqc">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 space-y-20 md:space-y-32" data-id="element-255" data-mp="1si363f11wc88">
        {/* Finance Spotlight */}
        <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center" data-id="element-256" data-mp="vslvcln7nzzo">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="order-1" data-id="element-257" data-mp="10q452e91yj8q">
            <div className="text-accent text-[13px] md:text-sm font-medium tracking-wide uppercase mb-3 md:mb-4" data-id="element-258" data-mp="h2mxyl3hcsl9">
              {t('spotlights.finance.badge')}
            </div>
            <h2 className="text-[40px] leading-[1.05] md:text-5xl font-display font-medium mb-4 md:mb-6" data-id="element-259" data-mp="2x6uc9k4polwi">
              {t('spotlights.finance.title')}
            </h2>
            <p className="text-white/60 text-[18px] leading-[1.5] md:text-lg font-light mb-8" data-id="element-260" data-mp="2ndnasad3dq1p">
              {t('spotlights.finance.desc')}
            </p>
            <button className="group flex items-center gap-2 text-white font-medium hover:text-accent transition-colors" data-id="element-261" data-mp="2dgs9xktcjdk9">
              {t('spotlights.finance.cta')}{' '}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-262" data-mp="29h9sx04nbmmp" />
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="order-2 h-[340px] lg:h-[600px] rounded-[2rem] glass-panel border border-white/10 relative overflow-hidden" data-id="element-263" data-mp="1zhiwuu0fszki">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.05),transparent_70%)]" data-id="element-264" data-mp="1i7ot5pjaiiic" />
            {/* Abstract Finance Graphic */}
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-265" data-mp="1n71ci0ayd7g6">
              <div className="w-72 h-72 border border-white/5 rounded-full relative flex items-center justify-center" data-id="element-266" data-mp="2axnilm1echnj">
                <div className="absolute w-full h-full border border-white/5 rounded-full scale-75" data-id="element-267" data-mp="2funpfz62lofp" />
                <div className="absolute w-full h-full border border-white/5 rounded-full scale-50" data-id="element-268" data-mp="210961xilgd0i" />
                <div className="absolute top-1/2 left-0 w-full h-px bg-white/5" data-id="element-269" data-mp="25zc9xemu8d6w" />
                <div className="absolute top-0 left-1/2 w-px h-full bg-white/5" data-id="element-270" data-mp="phg91s571o14" />
                <svg className="absolute inset-0 w-full h-full text-accent" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-271" data-mp="uivs5ent9kgv">
                  <defs data-id="element-272" data-mp="33pz75kvmsmdl">
                    <linearGradient id="finance-grad" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-273" data-mp="33qis7agkvqvu">
                      <stop offset="0%" stopColor="rgba(255,106,0,0)" data-id="element-274" data-mp="3dn3sjihnkdtc" />
                      <stop offset="50%" stopColor="rgba(255,106,0,1)" data-id="element-275" data-mp="2pzm0dluh7dpu" />
                      <stop offset="100%" stopColor="rgba(255,106,0,0)" data-id="element-276" data-mp="2l1c2v4la4112" />
                    </linearGradient>
                  </defs>
                  <path d="M0,80 Q25,70 50,40 T100,20" fill="none" stroke="url(#finance-grad)" strokeWidth="1.5" data-id="element-277" data-mp="2ytsayjt1ep8u" />
                  <circle cx="50" cy="40" r="2" fill="#FF6A00" className="animate-pulse" data-id="element-278" data-mp="2690iudkuhv39" />
                  <circle cx="100" cy="20" r="2" fill="#FF6A00" data-id="element-279" data-mp="2jy3l817150xo" />
                </svg>
              </div>
            </div>
          </motion.div>
        </div>

        {/* AI Spotlight */}
        <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center" data-id="element-280" data-mp="2ovdghxh3o6tf">
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="order-1 lg:order-2" data-id="element-281" data-mp="2tp7z0xkyyfqx">
            <div className="text-accent text-[13px] md:text-sm font-medium tracking-wide uppercase mb-3 md:mb-4" data-id="element-282" data-mp="3clg4a1dzeqm8">
              {t('spotlights.ai.badge')}
            </div>
            <h2 className="text-[40px] leading-[1.05] md:text-5xl font-display font-medium mb-4 md:mb-6" data-id="element-283" data-mp="1i7yh4fhhnvrq">
              {t('spotlights.ai.title')}
            </h2>
            <p className="text-white/60 text-[18px] leading-[1.5] md:text-lg font-light mb-8" data-id="element-284" data-mp="1ar20zvk6xtv1">
              {t('spotlights.ai.desc')}
            </p>
            <button className="group flex items-center gap-2 text-white font-medium hover:text-accent transition-colors" data-id="element-285" data-mp="110gz9z98097w">
              {t('spotlights.ai.cta')}{' '}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-286" data-mp="1tntd9l1bf8pl" />
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="order-2 lg:order-1 h-[340px] lg:h-[600px] rounded-[2rem] glass-panel border border-white/10 relative overflow-hidden" data-id="element-287" data-mp="1oqbdol96u5u9">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,106,0,0.08),transparent_70%)]" data-id="element-288" data-mp="2rixea1dq1bxw" />
            {/* Abstract AI Graphic */}
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-289" data-mp="2hjolvcyi85dn">
              <div className="relative w-64 h-64 scale-75 md:scale-100" data-id="element-290" data-mp="2hlssw3rp9ki5">
                <div className="absolute inset-0 border border-white/10 rounded-full animate-[spin_20s_linear_infinite]" data-id="element-291" data-mp="2mgojczhafzt5" />
                <div className="absolute inset-4 border border-white/10 rounded-full animate-[spin_15s_linear_infinite_reverse]" data-id="element-292" data-mp="27rsbp3j58ot2" />
                <div className="absolute inset-8 border border-white/10 rounded-full animate-[spin_10s_linear_infinite]" data-id="element-293" data-mp="1ytgn171u8139" />

                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-accent/20 rounded-full blur-xl animate-pulse" data-id="element-294" data-mp="23std00o09oa2" />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-accent/40 rounded-full blur-md" data-id="element-295" data-mp="1ttu9ewi3kitx" />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-white rounded-full shadow-[0_0_10px_rgba(255,255,255,1)]" data-id="element-296" data-mp="1a93jfoo3b421" />

                {/* Orbital Nodes */}
                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-accent rounded-full" data-id="element-297" data-mp="1k79nocxdcma2" />
                <div className="absolute bottom-4 left-4 w-1.5 h-1.5 bg-white/50 rounded-full" data-id="element-298" data-mp="1f5u0ofbms5p1" />
                <div className="absolute top-1/2 right-0 translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-white/80 rounded-full" data-id="element-299" data-mp="1t53g3cs0ivry" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}